import UsersManagement from "@/modules/users/views/UsersManagement"
import UsersPermissionGroups from "@/modules/users/views/UsersPermissionGroups"
import UsersCreate from "@/modules/users/views/UsersCreate"
import UsersUpdate from "@/modules/users/views/UsersUpdate"
import UsersPermissionGroupsUpdate from "@/modules/users/views/UsersPermissionGroupsUpdate"
import UserInheritedLogins from "../components/mockedApeiron/UserInheritedLogins.vue"

export default [
	// Plain users redirected to users/manage-users
	{
		path: "/:tenantId/users",
		redirect: "/:tenantId/users/manage-users"
	},

	// Manage Users
	{
		path: "/:tenantId/users/manage-users",
		component: UsersManagement,
		meta: { featureId: "users" },
		name: "UsersManagement"
	},
	{
		path: "/:tenantId/users/manage-users/create-user",
		component: UsersCreate,
		name: "UsersCreate"
	},
	{
		path: "/:tenantId/users/manage-users/update-user/:loginId",
		component: UsersUpdate,
		name: "UsersUpdate",
		props: true
	},
	// Permission groups
	{
		path: "/:tenantId/users/permission-groups",
		component: UsersPermissionGroups,
		meta: { featureId: "users" },
		name: "UsersPermissionGroups"
	},
	{
		path: "/:tenantId/users/permission-groups/update/:id",
		component: UsersPermissionGroupsUpdate,
		name: "UsersPermissionGroupsUpdate",
		meta: { featureId: "users" },
		props: true
	},
	{
		path: "/:tenantId/users/manage-users/update-user/:loginId/inherited-logins",
		component: UserInheritedLogins,
		name: "UserInheritedLogins",
		meta: { featureId: "users" },
		props: true
	}
]
